import React from 'react';

import { getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';

import { Actualite, Promo, Carrousel, Introduction, Mention } from 'modules/shared-cms-advanced/enhanced-blocs';
import { RubricBloc } from 'modules/shared-cms-advanced/components';

import { WeddingLanding2Props } from './wedding-landing-2-type';

import enhancer from './wedding-landing-2-enhancer';

import styles from './wedding-landing-2-page.module.css';

const weddingLanding2Page: React.FC<WeddingLanding2Props> = React.memo((props: WeddingLanding2Props) => {
    const {
        introId = getDefault(getNestedReferenceId(props.intro), ''),
        carrouselId = getDefault(getNestedReferenceId(props.carrousel), ''),
        rubricProps = {
            rubricTitle: props.rubricTitle,
            rubricTitleFontSize: props.rubricTitleFontSize,
            rubricSubtitle: props.rubricSubtitle,
            rubricSubtitleFontSize: props.rubricSubtitleFontSize,
            rubricColor: props.rubricColor,
            rubricItems: props.rubricItems,
        },
        actualiteId = getDefault(getNestedReferenceId(props.news), ''),
        promoId = getDefault(getNestedReferenceId(props.promo), ''),
        mentionId = getDefault(getNestedReferenceId(props.mention), ''),
    } = {};

    return (
        <div className={styles.root}>
            {introId !== '' && (
                <div className={styles.introWrapper}>
                    <Introduction id={introId} />
                </div>
            )}
            {carrouselId !== '' && (
                <div className={styles.introWrapper}>
                    <Carrousel id={carrouselId} />
                </div>
            )}
            {(rubricProps.rubricTitle || rubricProps.rubricSubtitle || rubricProps.rubricItems) && (
                <div className={styles.rubricWrapper}>
                    <RubricBloc {...rubricProps} />
                </div>
            )}
            {actualiteId !== '' && (
                <div className={styles.newsWrapper}>
                    <Actualite id={actualiteId} />
                </div>
            )}
            {promoId !== '' && <Promo id={promoId} />}
            {mentionId !== '' && <Mention id={mentionId} />}
        </div>
    );
});

export const WeddingLanding2Page = enhancer(weddingLanding2Page);
